module.exports = __webpack_public_path__ + "static/media/about.b1881e56.jpeg";